module.exports = __webpack_public_path__ + "img/Logo-menschen.fc7d1565.svg";